module.exports = __webpack_public_path__ + "DoodleAndDream.jpg?2249c1b38dcb705728f45a11b6df5ac4";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/DoodleAndDream.jpg
// module id = 464
// module chunks = 0